<script>
import InputMask from 'primevue/inputmask';
import Utils from '../../common/Utils';

export default {
    props: ['readonly', 'inputClass', 'modelValue', 'mask'],
    emits: ['update:modelValue'],
    components: {InputMask},
    data(){
        return{
            v: null
        }
    },
    created() {
        this.refreshValue();
    },
    watch: {
        modelValue(){
            this.refreshValue();
        }
    },
    methods: {
        refreshValue(){
            this.v = this.modelValue ? Utils.formatDateTime(Utils.dateToCurrentTimeZone(this.modelValue)) : null;
        },
        blurEvent(){
            if(this.v){
                if(this.v.length > 7){
                    let day = parseInt(this.v.substr(0,2));
                    let month = parseInt(this.v.substr(2,2)) - 1;
                    let year = parseInt(this.v.substr(4,4));
                    let hour = 0;
                    let minute = 0;
                    let second = 0;
                    if(this.v.length > 9){
                        hour = parseInt(this.v.substr(8,2));

                        if(this.v.length > 11){
                            minute = parseInt(this.v.substr(10,2));

                            if(this.v.length == 14){
                                second = parseInt(this.v.substr(12,2));
                            }
                        }
                    }

                    let d = new Date(year, month, day, hour, minute, second);
                    this.$emit('update:modelValue', Utils.dateToCurrentTimeZone(d));
                }else{
                    this.v = null;
                    this.$emit('update:modelValue', null);
                }

            }else{
                this.$emit('update:modelValue', null);
            }

        },
        updateModelValue(event){
            if(event){
                if(event.length == 14){
                    let day = parseInt(event.substr(0,2));
                    let month = parseInt(event.substr(2,2)) - 1;
                    let year = parseInt(event.substr(4,4));
                    let hour = parseInt(event.substr(8,2));
                    let minute = parseInt(event.substr(10,2));
                    let second = parseInt(event.substr(12,2));
                    let d = new Date(year, month, day, hour, minute, second);
                    this.$emit('update:modelValue', Utils.dateToCurrentTimeZone(d));
                } else {
                    if(this.mask && this.mask == '99/99/9999' && event.length == 8){
                        let day = parseInt(event.substr(0,2));
                        let month = parseInt(event.substr(2,2)) - 1;
                        let year = parseInt(event.substr(4,4));
                        let hour = '01';
                        let minute = '00';
                        let second = '00';
                        let d = new Date(year, month, day, hour, minute, second);
                        this.$emit('update:modelValue', Utils.dateToCurrentTimeZone(d));
                    }
                }
            }else{
                //this.$emit('update:modelValue', null);
            }
        },
    }
}
</script>

<template>
    <main>
        <InputMask 
            v-model="v" 
            @update:modelValue="updateModelValue"
            :mask="mask || '99/99/9999 99:99'"
            :disabled="readonly"
            :unmask="true"
            :autoClear="false"
            :class="inputClass || 'w-full'"
            v-on:blur="blurEvent"
             />
    </main>
</template>